import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 114,
	height: 221,
	fill: "none",
	viewBox: "0 0 114 221",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M74.7 56c.3 1-1.5 1.6.6 2.2-.6.1-3.1 2.8-5.9 1 3.7 6.7-11 1.6-.9 7.9 2 1.2 13 4.4 11.7 6-1.8.4-2.4 0-4.3.3-2 .3-7.6.6-8.6 1.5-4.9-4.8-4.4-1.7-7-1.5-.3 0-.8-1.2-1.9-1-.4 0-6.7 3.6-7-.6.2-.2.8 1.1 1.8-.3.2-.2 1.8-4.3 1.6-4.4-4.2.8-8.4.2-12.6 0 1.5-.7 1-2.2 2.2-2.6 0 0 .8.3 2.7 0 .1 0 1 1 2.2.5 1-1.3-1-1-1-1 0-1 1-1.6-1.2-2.7 1.7.4 1.6 0 2.8 1.6 2-6.5 7.5-1.7 8.5-2.1 1.5-.6 0-3.2.3-3.7l1.9-1.5c.2-.2 5.5-2.2 5.8-2.1.8 0 6 4.3 8.2 2.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M39.2 83.3c4.2.6 4.5 2.3 9.1 1.6-.3.6-1.3 2-1.2 2.4 2.6 3.2 3 .5 6.4.7 4.9 1.7-8 5-8.8 5.3-1-2-5.8-1-7.7-1-.5 0-.2-1.1-.3-1.1 2.2-.2-2.4-1.8-3-2.4-.3-.2.2-1.3 0-1.5-.9-.8-1.5.3-1.6.2-1.3-1.5.1-1.2-.3-1.8-.8-1.2-2-.6-2.4-3.2 3.3 1 6.7.5 9.8.8Zm3-16.3c4.2.3 8.4.9 12.6 0 .2.2-1.4 4.3-1.6 4.5-1 1.4-1.6 0-1.8.3-2.6 2.5.6 1 0 3.7l-11 2c2-3-3.7-1.9-5-3.9 4.2.5 13-3.1 4-3.4 2.4-3.3-2.8-.7-2.7-4 1.9.6 3.6.8 5.5.9Zm12.3-14.6c.8 0 .5.5.6.5-1.7 2.6-3 3 .6 3.7.9.2 2.7-.5 3 .5-.2.5 1.2 3.1-.3 3.7-1 .4-6.6-4.4-8.5 2-1.2-1.6-1.1-1-2.8-1.5-2-.5-3.1-1.5-3.3-1.6-.9 0-4 3.8-2.2-.7-9.7-1.2 5.6-2.5-3.7-3.2 2.4-1.7 6.3-.3 9-.8 2-.4 5.7-2.8 7.6-2.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "m52 82.8-1.5 2.6v-3.1c-1.6.6-1.5 1.4-2.2 2.6-4.6.7-4.9-1-9.1-1.6 0-2.4-2.5-4.4 1.2-5.7.5-.2 9-1.7 11-2.1 1.8-.4 2.8-2 4.3-.3L52 82.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M69.1 25.2c-3.3-2-1-.4-.6.5.5.8.9 1.7 1.9 2.3-1.1 1.7-2.3 0-3 .3-1.3.5-.3 1.4-1 2.1-1.6-3.7-2.3-2.5-6.1-1l.3-4.2c1.3 0 2.4 1.3 3.6-.3-2.3-2-6.1-6.6-.6-5.8l-1.8-1.5c0-.5 6.6-1.5 6.7-.6-1.7 3.3-.1 4.3-6 4.2 3.3 3 5.7 2.3 10 1.9-1.2 2.2-1.2 2.3-3.4 2Zm12.3 31.9c.7.9 1.6.4.6 1.9-2.2 3.1-10 5.7-13.5 8-10-6.2 4.6-1 1-7.8 2.7 1.8 5.3-.9 5.8-1 1.7-.5 4.5-.6 6-1ZM66 38.8c-.8-.6-3.8-2-3.6-2.9 2-1.8 5.3-1 8-1.3.9-.1 7.4-2 7.3-.3-1.7 2-7.7 1.5-4.3 3.7-3.7-.3-3.5 3-4 2.9-.1 0-1.5-2.5-1.8-2.6 0 0-.8 1-1.5.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M36.7 91.2s-.2 1 .3 1c2 0 6.8-1 7.7 1-2.3 1.1-5.9 3.1-6.8 5.3-2.6-.3.9-1.5-2.4-1.8l5.2-2.4c-.3-.7-8.8 1.6-9.5-1.5 2.3-.7 1.7-1.6 5.5-1.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DEE9FC",
			d: "M51.4 44.5c2.7 1.7-3 3.6 3.7 2.7.1 1.3-.7 1.3-1.9 1.5-1 .2-1.4-.5-1.5-.5-.6.2-4.4 4-2.4 0-2.7.8-5-.5-7.7-1.3 1.2-5.7 6 0 9.8-2.3Zm3.1-9.9c-.8.6-1.4 1.8-1.9 2.6-4 .1-5.2 2.2-8.5-1.3 3.3-1.7 6.5-1.3 10.4-1.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M56.3 26.7c.5 1.5.5 2-.6 3.2-3.3 3.4-3.4 1.1-5.5-.8 1.3-2.2 3.6-1.3 6.1-2.4Zm3.1-2.1c-1.8.1-.5 1.5-3.1 1-1 0-5.6-2.1-5.8-3.6H56c.9.2-.9 5 3 .5l.4 2.1Zm12.2 22.6c-2.9 1.3-6.8-.4-3.7-2.7h.6c3 .1 3.1-.8 5-.2-.1.5-1.9 2.7-1.9 2.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M48.3 64s2.1-.3 1 1c-1.3.5-2-.6-2.2-.5l1.2-.6Zm20.8-38.8c-.4 0-.6 0-.6.5-.5-.9-2.7-2.5.6-.5Zm22.7 167.7c.2.6.2.7 0 1.5-1.2.2-2.9 1-3.7 1.9.2 1.6 16.5 4 14 6.8-.7.8-12-2.7-10.3 0L104 206c-.3 8.1 3.4 10.8-8.5 10.4-.3-.5.3-1.6-.4-2-3-2.1-8.6-.5-9.1-.6-5.5-1-10.4-4.2-12-8.9l-.6-1.8c2.9-1 7.4 6.8 8 2 0-.7-9.5-11.7-10.7-12.8-1.2-1-6.9-4.4-9-4.2 0-.3-2.3 1.3-.8-2-4 0-3-2.7-3.7-3.2-.4-.3-1.5 1-2.1.5 2.5-2.3-2.6-4.7-2.5-5 .4-1 4-.7 3.4 1.9 1.7-4.5 5.8 2.6 3.4-3-.2-.8.7-.8 1.5-.7 2.4.4 15.3 10.7 16.5 10.5.7-.2 1.1-2 1.8-2.1 1.5-.2 8.6 9.4 12.6 7.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DEE9FC",
			d: "M55 192.3c3-1.8 2.9 5.3 3.7 7.4-.8-.4-1.4.5-1.5.5-.7-.3.1-1.7-.6-2.1-.6-.4-11.3 7-12.8 7.9-1.9.9-4.2.1-6.2 1-1.2.6-2.9 4.5-5.5 4.7l-.6-4.2c-4.1 4.8-4.6 1.6-5.8 1.6h-1.2l3-2.4c-3.9-.7.3-.6-.3-2.3-1.3 0-6.9 3.2-7.3 3.1-1.8-.1.1-1.2-2.1-1.5v-1c1.5-.5 9.5-5.4 10-5.3 1 0 1.5 2.3 3.1 2 .8 0 9.5-8.7 12-9.9.2-.1 3.9 1.3 5.1-2 .7 8.8 1.5 10 7 2.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M58.7 199.7c1 .4 1.2 1 1.3 1-1.6 2-2.4-1-5.5.8-1.5.9-11.2 14.2-6.5 13.9l3.4-2.9c.5 2.1-1.9 4.4.6 6-2.7.7-1.6-2-4-2-.5 0-2.3 1.5-2.4 1.5-5.7.6-11.5.8-17.1 1.6l-.7-1 4-5c-1-2.4-9.4 3.8-6.1-4.5 1.2 0 1.7 3.2 5.8-1.6l.6 4.2c2.6-.2 4.3-4.1 5.5-4.7 2-.9 4.3-.1 6.2-1 1.5-.8 12.2-8.3 12.8-7.9.7.4 0 1.8.6 2 0 .1.7-.8 1.5-.4Zm36.8 16.7c0 .1-1.5.8.9 2.1l3 1c-6.9-.3-13.9.2-20.8 0-.3 0-4.2-1.5-4.9-1.5l-4.2 1.6c-1.2 0-1.6-1-1.9-1-.4 0-1.2 1.6-2.4 1.5-1.3 0-3.6-2.5-4-2.6 2.8-1.4-.9-5.3 2.1-6.8 1.6.9 10 2 10.7.2.6-1.6-2.6-3.4-1.2-5 .1 0 1.7.4 1.2-1 1.6 4.7 6.5 7.8 12 9 .5 0 6.2-1.6 9.2.4.7.5 0 1.6.3 2.1Zm8.5-19.9c-4.5 1.6-.8-1.5-2.1-2-2-1-6.2 1-6.7 1l-3.4-1c.2-.9.2-1 0-1.6-.3-1-1.8-3.2-1-3.7l11.7 2-2.4-3c1.3.7 8.3 4.4 8.2 1.2l-3-2.6 6-1c-4-1.8-8.7-2.8-11.6-6 4.1.1 4 4 4.3 4h9.8c-1.8 0-7.2 4.8-4.8 4.3 3.7 9 2.1 10.4 3.8 10.4-1.2 4-8.7-5-9.4-3.3-.2.7.7.8.6 1.3Zm-79.5 12.6c-2.2 0-5 1-5.2 1-.6 0-6.3-1.4-7.7-1.5 2.7-.9 3.2-3 6.1-2.6 2.3.3.4 1.4 2.2 1.5.4 0 6-3 7.3-3.1.6 1.7-3.6 1.6.3 2.3l-3 2.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M67.3 75c-2 2 5.7 5.2 6.4 5.2.5 0 0-.8 1-1 1 3 11.3.7 11.9 1 .2 0-.5 2.6 2.7 2.9-4.5 1.3-6.2 3-9.8 5-1-.7-2.5-.3-2.4-1.4 5.1 0 2.2-2.3-1.2-2.8-4.1-3.6-3.7 1.1-5.8.5-2-.6.8-2.6-3.4-2.1 0-1.6.7-3.5-1.8-2.1-4.2 2.2-1.2.2-3.4 0-2.7-.3-1.9 1.1-3 1-.2 0-1.3-2-2.5-1.5-1 .3-1.4 4.4-4 3.1l3.7-7.6c-1.5-1.7-2.5-.1-4.3.3.6-2.7-2.6-1.2 0-3.7.3 4.2 6.6.6 7 .5 1.1 0 1.6 1 1.9 1 2.6-.1 2.1-3.2 7 1.6Zm3.1 50.8c1.9 4.4 10.3 6.6 15.3 6.8l-1.3 2c-7.3.9.2 1.5-2.7 4.8-2.4-2.9-5.8-.8-6.1-1-.8-.6.6-3.5-1.9-3.7-3-.3.6 3.2-5.5-1-.4-.4-1.3 1.4-2.7-1.4-.8-1.6 2.3-2-2.5-3.6 3-.9 5.9-3.1 7.4-3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M88.1 126.8c2.1-1 3.7.2 5.5 1-2 2.1-2.8 1.7-4.3 3-.2.1 4 2-3.6 1.8-5-.2-13.4-2.4-15.3-6.8 1.3.2 3.8 1.7 4 1.6.8-.6-.6-2 1.2-2.1.5-.1 7.7 4.3 9.8 4.1 1.9 0 1.4-2 2.7-2.6ZM79.5 88c2 1.3 5.2 3.9 6.2 5 .9 1.2.7 3.3 2.4 4-.2 0-3.8.6-4.9 0-3-1.6-5.8-3.6-9.5-4.2l1-1.6c1 .1 4.2.2 4.8-.8-.5-2-4.7-1.5-3.6-4.2.3-.8 3.6.8 0-2.3 3.4.5 6.3 2.7 1.2 2.8 0 1.1 1.5.7 2.4 1.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DEE9FC",
			d: "M88.1 97c7.5 1 2.5 3.4 2.5 3.9 0 1 1.7.9 1.8 1.6 0 .4-1.2.2-1.2.2l-3.7.8c3.8 2.7 1.9 3.2-1.2 3.4-.2-2-1.9-3.5-3.7-4.7.7-1.4 2.4-2 4.3-2.6.7.1 2.3 0 3-.3-2.4-1.7-2.5.1-3 .3-1.4-.3-3-2.3-3.7-2.6 1 .6 4.7 0 5 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m75.9 73.4 2.4 4.2c-1 .3-2.8 1.3-3.6 1.5-1 .3-.5 1-1 1-.7.1-8.4-3.2-6.4-5.2 1-.9 6.7-1.2 8.6-1.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DEE9FC",
			d: "M91.2 102.7c.4 3.8 3.7 1.8 4.3 2.9 0 .2-3.1 3.9-3.4 4-.3 0-5.3-.6-6.1-1.1-1.2 2 3.5 1.3 2.1 3.1-2-1.4-4.6-2-6.7-3.1l1.2-1.6c.8.2 2.7 0 3.7 0 3-.2 5-.7 1.2-3.4l3.7-.8Zm2.4 25.2c-1.8-.9-3.4-2-5.5-1 .9-.6-1.9-2.8-3-3.7 7.6-3 4.3 4 10.7 2-.8.6-1.8 2.3-2.2 2.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M41 111.6s-1.4-.3-.3-1c1.1-.8 4.8-1 5.2-1.9 0 0-1.7-1.2-.6-2.6.2-.2 4-2.4 5.5-4 1.3-1.2 4.4-5.6 4.9-6 1-.9 9.6 3.8 9.8 4.3.3.8-1.9 1-.6 2.6.3.4 2.8.8 3 1.6.5 1.6-4.5 2.6 0 5.7-2-.6-4.3 1.8-4.6 1.9-.4 0-3.4-1.7-3.6-1.6-.6 0-1.4 2.3-2.5 2.6-.5.1-5.7-.5-7.3 2.1v-3.7c-.4 1-5.2 3.2-5.5 3.2-2.6.1-1-3-3.4-3.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M59.4 24.6c.5 0 .6.6 1.2.6l-.3 4.2c3.8-1.5 4.5-2.7 6 1 .8-.7-.2-1.6 1-2 .4 2.6 1.4 3.9 3 6.2-2.6.2-5.9-.5-7.9 1.3-.2 1 2.8 2.4 3.7 2.9-4.8.2 2.8 4.5 2.4 5.8H68c-5.2-.3 1 1.4-4 2-5.2-5-4-.5-5.8 0l-3 .6c-6.6 1-1-1-3.7-2.7a5 5 0 0 0 1.2-7.3c.5-.8 1-2 1.9-2.6.1-.1 1.3.3 1.8-.3 0 0-1-.3-.3-1.3 0 0 1 1.2 1.5.3.4-.6.4-3.7-1.8-3.4 1-1.2 1.1-1.7.6-3.2v-1c2.6.4 1.3-1 3-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m56 35.6 2.1.8c2 2.6-6.6 4.2-2.1-.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M63.3 44.5c.5-.2 1.6.8 1.6.8-.5.9-3 0-1.6-.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M59.7 34.6c1.4.1.3 2.3-.7 1-.4-.5.6-1 .7-1Zm8.3 10c-3.2 2.2.7 3.9 3.6 2.6-.7 4.2 5.9 2 9.8 3.9-1.4 4.5-5.3 1.2-8.6 3.1 1.1.3 1.5 1 1.9 1.9-2.3 1.7-7.4-2.5-8.3-2.6l-5.8 2c-.6-.7 2-4 1.8-4.4-.4-.8-1.4.5-1.8 0-1.3-1.6-1-3.3-2.5-4.5 1.8-.5.6-5 5.9 0 5-.6-1.3-2.3 4-2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M62.1 49.3c3.7 2.3 4.6.3 6.7.5 3 .3-2.2 2.3 0 2.6 1.5.2 3.3-.3 4.6.3.4 2-12-.9-11.3-3.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DEE9FC",
			d: "M61.5 0c3 3.4-2.5 9.5 4.6 8.1-4.9 5.1-2.2 2.6-.6 5.3.3.5-3.1.6 1.2 1.5-2.2 2-4.8 0-8.3.8 2.2 2.9-.3 3 1.6 5.5l-1.6.8c-6-2.8-5.8-7 1.6-7.6-5.4-1-7.6-5.2 0-2.6C57.5 11 60.8 0 61.5 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M60.9 10.5c.4 0 1.5 1.5.6 1.6-.4 0-1.5-1.5-.6-1.6Zm-4.3 6.3c.3 0 .4.4.3.8-.3 2-1-.8-.3-.8Zm1.5 29.8c1.5 1.2 1.2 3 2.5 4.5.4.5 1.4-.8 1.8 0 .2.5-2.4 3.7-1.8 4.5L58.7 57c-.3-1-2.1-.3-3-.5 1.6-.7-.2-3.4-.6-3.7 0 0 .2-.4-.6-.5l-1.3-3.7c1.2-.2 2-.2 1.9-1.5l3-.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M55.7 56.6c-3.5-.7-2.3-1-.6-3.7.4.3 2.2 3 .6 3.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M57.8 50.8c4.4-.2-1 4-1.5 1.3l1.5-1.3Zm22.4 103.8c4.1 1 9.2 3.3 13.4 4.7 1.1.4 3.9.3 4.6.5 2.4.8 5.8 4 6.7 4.2.2.1 3.2-1.6 4 .6-1.7.3-3.4.7-4.9 1.5-.3.2-.7-.4-1.2.6-2.9-.4-6-3.3-3 .7-1.8 2-3.6-1.3-5.3-2.3-1.6 1.6 3.9 5.1-1.5 2.6-1.5-.7-3.4-3.4-5.2-2.6-1 .4.3 4.2-5.8.5-.2-.1-2-3.2-3.4-3.1-.3 0-.2 1.5-1.8 1.5-.6 0-8.6-5.9-11-5.7-1.3-2.8 1.2-.1 1.5-1.9l-4.3-3.1 6.5 2.9-.7-3.7c2.7 2.7 9.6 1.7 11.4 2.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M102.8 166.7c-1.5 2.6 5.5 3.8 5.5 4.4 0 3-3 .9-4.3 2.1-1 1-.1 4.5-6.4 3.4-1.4-.2-2.2-2.5-4-3.1 5.2-.5-1.6-3.4-.6-5.8 5.4 2.5 0-1 1.5-2.6 1.7 1 3.5 4.4 5.2 2.3-2.8-4 .2-1 3.1-.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M93 167.7c-1 2.4 5.8 5.3.6 5.8-2.3-.9-10.2-2.7-11.6-4.2-1.3-1.4-1.5-2.1 0-3.7 6 3.7 4.9-.1 5.8-.5 1.8-.8 3.7 1.9 5.2 2.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M42.8 191.8c-2.4 1.2-11 9.9-11.9 10-1.6.2-2.2-2-3-2.1-.6 0-8.7 4.8-10.2 5.2-.3 0-6 .7-6.4.5-1-.4 1-1.6 0-2C10 202.6.3 205 0 203c1.2-2 5-1.6 6.4-2.4 8-4.2 5.5-2.7 13.8-5.2 5.7-1.7 13.2-4.3 14.7-10.2.7-2.7-1.5.5-1.9-1 4.7-3.8 7.4-8.5 14.4-6.1l1 1.3c-4.1 2.4-4.6 8.4-5.6 12.3Zm1.2-21.5c-3.7 3-12.4 3.5-7.9 6.8-2.2 1.5-3.9 3.6-5.8 5.3-5.2-4.6-4.9.1-7.3 0-1 0-2-3.5-5.9.5.4-.5 2-2.7 1.9-3.1-.2-1.4-4-2.8-5-4 4-1.8 8.9-5.7 13-6 7.2-.6 12.2 2.4 19.8-2.1-.1 1-1.8 1.9-2.7 2.6Zm-1.8-14.1c-.6.2-2-.3-2.4.2l1.2 1.9a39 39 0 0 1-7.3 2l1.5-3c-3.2.1-6.3 1-9.5 1-2.1 0-2.8-.1-4.9-.6-.8-.1-3.2.6-2.1-1 6.1-.7 12-2.4 18-3.7 3.9-.8 7.6-1.2 11.3-2.6-.9 2.3-6.1 2-2.1 4-1 .9-2.3 1.3-3.7 1.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M37.3 141c-.8 1-1.7 1-1.8 1.3-.9 1.4 2.6-.6-.6 2.3l-5.5-1.5c2.8-.6 5.3-1.2 8-2.1Zm-11.6 17.3c.5 2.4-8.7 2.4-4.9-.6 2 .5 2.8.5 4.9.6Zm3.7 2.6c-1.4-.3-.2-1.7.9-1.6.5.6-.8.9-1 1.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M74 205c.5 1.3-1 .9-1.2 1-1.8 0-6.6-4.8-7-4.8-2.2 0 1.1 2.7-5.8-.5-.1 0-.3-.6-1.3-1-.8-2-.6-9.2-3.6-7.4 2.2-3 1-4.1 5.8-1.5 1.3-1 1.2-1.4.9-2.7 2-.2 7.7 3.2 8.9 4.2 1.1 1 10.8 12 10.7 12.9-.6 4.7-5.1-3.1-8-2.1l.6 1.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M60 200.7c7 3.2 3.6.6 5.8.5.4 0 5.2 4.7 7 4.8-1.4 1.5 1.7 3.3 1.2 5-.7 1.6-9 .6-10.7-.3-3 1.5.7 5.4-2.1 6.8-7.4-3.2-4.4 0-9.2 1-2.5-1.6 0-3.9-.6-6l-3.4 2.9c-4.7.3 5-13 6.5-13.9 3-1.9 3.9 1.2 5.5-.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M57.8 202.3c.4 0 .8-.1 1 .3-1.2.8-2.1 2.5-3.7 1.5.2-.8 2.3-1.8 2.7-1.8ZM85 143c-1.7 5.5 2.1 6.6 8.6 6.9.6 1.8 2.9 1.3 3.7 1.8 2.3 1.5 0 3.3 2.4 4-1.3.6.2 3.2-5.2 1l-.9 2.6c-4.3-1.4-9.3-3.8-13.4-4.7 3.3-5-1.3-3.8-1.9-5.5-1-3 5.7-3.5-.6-6.3l7.4.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m74.7 91.2-1 1.6c3.7.6 6.4 2.6 9.5 4.2.6.3 2.3 2.3 3.7 2.6-1.9.6-3.6 1.2-4.3 2.6-3.8-2.6-5.6-3-9.2 0-.6-2.9-3.2-3.7-5.5-5.5 0 0 1-.6.6-1-.2-.3-5 1.2-5.5-3.2 6 .4 3.7 0 4.6-4.5a17 17 0 0 0 7 3.2ZM88.1 142c2.6.5 11.7 1.7 13.2 2.1.5.2.2 1 .3 1l-7.7 1.6c-.2 1.3 3.2 1.6 4 1.6 1.5 2-2.7 1.6-4.3 1.6-6.5-.3-10.3-1.4-8.5-6.8.3-1-1.3-1.3.3-2.1.6 0 .8.7 2.7 1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M82.6 102.2c1.8 1.2 3.5 2.7 3.7 4.7-1 0-2.9.2-3.7 0-3.4-.6-6.2-2.8-9.2-4.2v-.5c3.6-3 5.4-2.6 9.2 0Zm-46.5 74.9c-4.5-3.3 4.2-3.8 8-6.8.6 4.3-5 4.9-8 6.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M64.9 80.2c2 0 1.5 2.2 0 2.3 2 2 1.6-.2 1.8-.2 4.2-.5 1.4 1.5 3.4 2 2.1.7 1.7-4 5.8-.5 3.6 3.2.3 1.6 0 2.4-1.1 2.7 3 2.1 3.7 4.2-.7 1-3.9 1-5 .8a17 17 0 0 1-7-3.2c-.9 4.5 1.4 4.9-4.6 4.5.4 4.4 5.3 2.9 5.5 3.1.5.5-.6 1-.6 1 2.3 2 4.9 2.7 5.5 5.6v.5c-1.5-.7-3-1.6-4.6-2a67 67 0 0 0 12.6 7.8c2.1 1.1 4.7 1.7 6.7 3.1-2.5 3.4-8-1.8-8.5-.8 2.7 3.8 4.3 5.5 9.1 7.4 0 1.4-7.8 1.3-9.1 1 2.7 1.1 3.6 2.4 5.5 4 1.1 1 3.9 3 3 3.6-1.3.6-.8 2.5-2.7 2.6-2 .2-9.3-4.2-9.8-4.1-1.8.1-.4 1.5-1.2 2-.2.2-2.7-1.3-4-1.5-1.5-.2-4.4 2-7.4 2.9 4.8 1.6 1.7 2 2.5 3.6 1.4 2.8 2.3 1 2.7 1.3 6.1 4.3 2.5.8 5.5 1 2.5.3 1 3.2 1.9 3.8.2.2 3.7-1.9 6 1 3-3.3-4.5-4 2.8-4.7 2.9-.3 8.4 1.2 5.6 4.2-.7 0-1.1-1-1.9-.3 1.7 1.6 1.1 1.6 0 3.4-1.9-.3-2-1-2.7-1-1.6.8 0 1.2-.3 2l-7.4-.2c6.3 2.8-.4 3.3.6 6.3.6 1.7 5.2.4 1.9 5.5-1.8-.4-8.7.6-11.4-2l.7 3.6-6.5-3 4.3 3.2c-.3 1.8-2.8-.8-1.5 1.9 2.4-.2 10.4 5.7 11 5.7 1.6 0 1.5-1.5 1.8-1.5 1.4-.1 3.2 3 3.4 3.1-1.5 1.6-1.3 2.3 0 3.7-.8 6.6 4.2 6.2 9.5 7.8.9.3 2.7.5 1.5 1.6-1.7-.3-7.6-2.6-8.9-2-.5.1 0 1.5-1.2 2-.5.2-9-.1-9.8-.5l1.2 3.1c-1.2-1.7-6.4-1.6-7.3-2-2-1-6.2-6.7-6.7-6.9-1.8-.4-2.7 2-3.7 1.6-1.3-.5 1.6-1.3-5.2-2.1l3.4-3.1c-2-.4-3.6 2-4.6 2.6-1 .5-4.6.6-4.3 1.8 6 .4 2 .2 2.4 2.1 1 3.4 3.2 5.8 6.8 8.1.6.4 1.7-.8 2.1-.5.7.5-.3 3.1 3.7 3.2-1.5 3.3.8 1.7.9 2 .3 1.3.4 1.7-1 2.7-4.7-2.6-3.5-1.5-5.7 1.5-5.6 7.6-6.4 6.3-7-2.6-1.3 3.4-5 2-5.3 2.1 1-3.9 1.5-9.9 5.5-12.3l-.9-1.3c-7-2.4-9.7 2.3-14.4 6 .4 1.6 2.6-1.6 1.9 1-1.5 6-9 8.6-14.7 10.3l1.3-4.7c3.8-1 2-2.6 4.2-5.5-3.2-.3-7.4.4-10.4-.3.5-.8 1.3-1.3 1.8-2 3.9-4.1 4.9-.7 5.8-.6 2.5.1 2.2-4.6 7.4 0 2-1.7 3.6-3.8 5.8-5.3 3-2 8.6-2.5 8-6.8 1-.7 2.6-1.6 2.7-2.6-7.6 4.5-12.7 1.5-19.9 2.1 0-3.6 1.8-5.2 2.5-9 1.4.1 2.8-.2 4.3-.4a44 44 0 0 0 7.3-2.1c1-.7 1.6-.7 1.2-2.1a10 10 0 0 0 3.7-1.9c-4-1.8 1.2-1.6 2.1-3.9-3.7 1.4-7.4 1.8-11.3 2.6-5.1-4.1 3.8-2.7 3.4-6.3-1.9.3-9 3.1-10.1 1.9 1.4-1.7 3.2-2.4 4.9-4 3.2-3-.3-.9.6-2.3.1-.2 1-.3 1.8-1.3 0 0 1-.4 1.2-.8l-1.8-1.3c.6-.3 2.4-2.8 3.4-3.2 3.7-1.2 3.3 1 3.6 1 .5.2 3.8-3.3 6.5-4.6 4 1.7 2 .3 3-1 .5-.7 2.4-1.9 1.6-3.2L43 133c-3.1.5 1.3-2.3-1.8-1.5-2.2.5-11.5 4.7-9.5-1.4.3-.7 12-4.2 12.9-7.3 0-.1-1.8-1.5-1-2.9-5.8 3.3-6.7-1.8-.9-3.4-1-1.3-2 0-3 .3l-1.3-3.7c1-.4 1.7-1 2.5-1.6 2.5.2.8 3.3 3.4 3.2.3 0 5.1-2.3 5.5-3.2v3.7c1.5-2.6 6.8-2 7.3-2 1-.4 1.8-2.6 2.5-2.7.2 0 3.2 1.6 3.6 1.6.3 0 2.6-2.5 4.6-1.9-4.5-3.1.5-4.1 0-5.7-.2-.8-2.7-1.2-3-1.6-1.3-1.5 1-1.8.6-2.6-.2-.5-8.7-5.2-9.8-4.2-.5.4-3.6 4.7-5 6h-8.2l1.2-5.2c-.4.9-5.5 1.6-5.8 1.5 1-2.2 4.5-4.2 6.8-5.2.7-.3 13.7-3.6 8.8-5.2-3.5-.3-3.8 2.4-6.4-.8-.1-.5 1-1.8 1.2-2.4.7-1.2.6-2 2.2-2.6v3.1l1.5-2.6c2.6 1.3 3-2.8 4-3.1 1.2-.4 2.3 1.5 2.4 1.5 1.2.1.4-1.3 3-1 2.3.2-.7 2.2 3.5 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M58.4 132c1.6 0 7 8 6.2 8.5-1.5.4-5.2-3.2-5.5-3.2-.4 0-3.7 3.5-5.3.8-1.2-2.2 3.2-4.5 4.6-6Zm-3.6 14.2 4.6 1.8c.1.2-1 3.6-.3 4.5l-5.9-4.5c.8-.2 1.4-1.8 1.6-1.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M73.4 102.7c3 1.4 5.8 3.6 9.2 4.2l-1.2 1.6c-4-2.2-9.5-5-12.6-7.9 1.7.5 3.1 1.4 4.6 2.1ZM56 121c3.9 2.8-11 9.7-10.7 7.7 3.6-2 10-3.4 10.7-7.6Zm-4.3 12.6c0 2.5-3.3 4.2-5.5 5.3-2.3-1.1 5.3-4.4 5.5-5.3Zm2.5 26.8v5.7c-2.4-1.9-1.5-3.6 0-5.7ZM78 122.6l5.8 3c-.2.5-6.5-1.3-5.8-3ZM70.7 165c1-.4 3.4 1.7 3.3 2-.3 2.7-5.3-.8-3.3-2Zm-2.5-16.7 5.2 2.4c-1.4 1.4-5-1.2-5.2-2.4Zm-16.8 23.6c-.6 0-.7-.6-1.2-.5 1-.6 2.5-3 4.6-2.7l-3.4 3.2Zm15.3-89.6c-.1 0 .3 2.2-1.8.2 1.5 0 2-2.4 0-2.3 2.5-1.4 1.7.5 1.8 2Zm-5.8 64.4c.4.2 4 2.2 2.4 2.7-.8-.7-3.3-1.2-2.4-2.7Zm-14.7 8.9c1.3 1.8-1.3 1.7-2.5 2.7l2.5-2.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DEE9FC",
			d: "M42.2 156.2c.4 1.4-.2 1.3-1.2 2l-1.2-1.8c.3-.6 1.8 0 2.4-.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M57.2 92.8c1.6-.4.3 1-.6 1.5-.8-.4.2-1.4.6-1.5Zm3.1 62.8c.8-.5.6 2.4 0 2.1-.5-.2-.5-1.7 0-2Zm41.3-10.4c4 2.3-1.6 2-2.2 2-.3.1-.8 1.1-1.5 1.1-.8 0-4.2-.3-4-1.6l7.7-1.5ZM86.9 99.6c.5-.2.6-2 3-.3-.7.4-2.2.4-3 .3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M51.4 171.9c6.8.8 3.9 1.6 5.2 2 1 .5 2-2 3.7-1.5.5.2 4.7 5.8 6.7 6.8.9.4 6 .4 7.3 2.1l-1.2-3.1c.8.4 9.3.7 9.8.5 1.3-.5.7-1.9 1.2-2 1.3-.7 7.2 1.7 9 2 2.1.4 4.4 1 6.6 1 3 3.3 7.5 4.3 11.7 6l-6.1 1.1 3 2.6c.1 3.2-7-.5-8.2-1.3l2.4 3.2-11.6-2.1c-1 .5.6 2.8.9 3.7-4 1.5-11-8.1-12.6-8-.6.2-1 2-1.8 2.2-1.2.2-14.1-10-16.5-10.5-.8-.1-1.7-.1-1.5.8 2.5 5.5-1.6-1.6-3.4 2.9.7-2.6-3-2.9-3.4-1.9 0 .3 5 2.7 2.5 5-3.6-2.3-5.8-4.7-6.8-8.1-.5-2 3.7-1.7-2.4-2.1-.3-1.2 3.3-1.3 4.3-1.8.5 0 .6.4 1.2.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "M53.5 173c1.6 1-1.1 4.2-1.8 4.1-2.7-.3.4-5.1 1.8-4.2Z"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#a)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 46.1,
				cy: 144.7,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 46 144.7)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#b)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 64.1,
				cy: 119.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 64 119)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#c)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 55.1,
				cy: 93.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 55 93)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#d)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 66.1,
				cy: 57.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 66 57)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#e)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 80.1,
				cy: 148.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 80 148)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#f)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 64.1,
				cy: 172.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 64 172)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#g)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 88.1,
				cy: 205.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 88 205)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#h)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 103.1,
				cy: 181.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 103 181)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#i)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 46.1,
				cy: 144.7,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 46 144.7)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#j)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 64.1,
				cy: 119.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 64 119)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#k)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 55.1,
				cy: 93.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 55 93)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#l)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 66.1,
				cy: 57.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 66 57)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#m)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 80.1,
				cy: 148.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 80 148)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#n)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 64.1,
				cy: 172.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 64 172)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#o)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 88.1,
				cy: 205.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 88 205)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#p)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 103.1,
				cy: 181.1,
				r: 1.5,
				fill: "#FFDFA2",
				transform: "rotate(50.6 103 181)"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 46.1,
			cy: 144.7,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 46 144.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 64.1,
			cy: 119.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 64 119)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 55.1,
			cy: 93.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 55 93)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 66.1,
			cy: 57.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 66 57)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 80.1,
			cy: 148.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 80 148)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 64.1,
			cy: 172.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 64 172)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88.1,
			cy: 205.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 88 205)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 103.1,
			cy: 181.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 103 181)"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#q)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -203.1 -20.3)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#r)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -167.1 -14)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#s)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -144 -36.6)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#t)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "matrix(-.635 .773 .773 .635 70 62)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#u)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "matrix(-.635 .773 .773 .635 48.9 77)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#v)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -64.2 -51)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#w)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -151.3 5.7)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#x)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -189.8 17.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#y)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -191.8 40.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#z)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -223.2 12.5)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#A)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -246 54.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#B)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -213.2 58.2)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#C)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -203.1 -20.3)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#D)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -167.1 -14)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#E)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -144 -36.6)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#F)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "matrix(-.635 .773 .773 .635 70 62)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#G)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "matrix(-.635 .773 .773 .635 48.9 77)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#H)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -64.2 -51)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#I)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -151.3 5.7)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#J)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -189.8 17.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#K)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -191.8 40.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#L)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -223.2 12.5)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#M)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -246 54.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#N)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -213.2 58.2)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#O)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -203.1 -20.3)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#P)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -167.1 -14)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#Q)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -144 -36.6)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#R)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "matrix(-.635 .773 .773 .635 70 62)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#S)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "matrix(-.635 .773 .773 .635 48.9 77)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#T)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -64.2 -51)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#U)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -151.3 5.7)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#V)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -189.8 17.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#W)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -191.8 40.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#X)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -223.2 12.5)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#Y)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -246 54.4)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#Z)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 1.5,
				cy: 1.5,
				r: 1.5,
				fill: "#FDC564",
				transform: "scale(-1 1) rotate(50.6 -213.2 58.2)"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -203.1 -20.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -167.1 -14)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -144 -36.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "matrix(-.635 .773 .773 .635 70 62)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "matrix(-.635 .773 .773 .635 48.9 77)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -64.2 -51)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -151.3 5.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -189.8 17.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -191.8 40.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -223.2 12.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -246 54.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "scale(-1 1) rotate(50.6 -213.2 58.2)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "a",
				width: 11,
				height: 11,
				x: 40.6,
				y: 139.2,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "b",
				width: 11,
				height: 11,
				x: 58.6,
				y: 113.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "c",
				width: 11,
				height: 11,
				x: 49.6,
				y: 87.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "d",
				width: 11,
				height: 11,
				x: 60.6,
				y: 51.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "e",
				width: 11,
				height: 11,
				x: 74.6,
				y: 142.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "f",
				width: 11,
				height: 11,
				x: 58.6,
				y: 166.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "g",
				width: 11,
				height: 11,
				x: 82.6,
				y: 199.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "h",
				width: 11,
				height: 11,
				x: 97.6,
				y: 175.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "i",
				width: 11,
				height: 11,
				x: 40.6,
				y: 139.2,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "j",
				width: 11,
				height: 11,
				x: 58.6,
				y: 113.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "k",
				width: 11,
				height: 11,
				x: 49.6,
				y: 87.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "l",
				width: 11,
				height: 11,
				x: 60.6,
				y: 51.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "m",
				width: 11,
				height: 11,
				x: 74.6,
				y: 142.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "n",
				width: 11,
				height: 11,
				x: 58.6,
				y: 166.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "o",
				width: 11,
				height: 11,
				x: 82.6,
				y: 199.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "p",
				width: 11,
				height: 11,
				x: 97.6,
				y: 175.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "q",
				width: 13,
				height: 13,
				x: 83.6,
				y: 145.2,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "r",
				width: 13,
				height: 13,
				x: 65.6,
				y: 119.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "s",
				width: 13,
				height: 13,
				x: 74.6,
				y: 93.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "t",
				width: 13,
				height: 13,
				x: 63.6,
				y: 57.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "u",
				width: 13,
				height: 13,
				x: 42.6,
				y: 72.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "v",
				width: 13,
				height: 13,
				x: 56.6,
				y: 26.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "w",
				width: 13,
				height: 13,
				x: 44.6,
				y: 114.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "x",
				width: 13,
				height: 13,
				x: 49.6,
				y: 148.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "y",
				width: 13,
				height: 13,
				x: 32.6,
				y: 158.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "z",
				width: 13,
				height: 13,
				x: 65.6,
				y: 172.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "A",
				width: 13,
				height: 13,
				x: 41.6,
				y: 205.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "B",
				width: 13,
				height: 13,
				x: 26.6,
				y: 181.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "C",
				width: 13,
				height: 13,
				x: 83.6,
				y: 145.2,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "D",
				width: 13,
				height: 13,
				x: 65.6,
				y: 119.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "E",
				width: 13,
				height: 13,
				x: 74.6,
				y: 93.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "F",
				width: 13,
				height: 13,
				x: 63.6,
				y: 57.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "G",
				width: 13,
				height: 13,
				x: 42.6,
				y: 72.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "H",
				width: 13,
				height: 13,
				x: 56.6,
				y: 26.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "I",
				width: 13,
				height: 13,
				x: 44.6,
				y: 114.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "J",
				width: 13,
				height: 13,
				x: 49.6,
				y: 148.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "K",
				width: 13,
				height: 13,
				x: 32.6,
				y: 158.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "L",
				width: 13,
				height: 13,
				x: 65.6,
				y: 172.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "M",
				width: 13,
				height: 13,
				x: 41.6,
				y: 205.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "N",
				width: 13,
				height: 13,
				x: 26.6,
				y: 181.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "O",
				width: 13,
				height: 13,
				x: 83.6,
				y: 145.2,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "P",
				width: 13,
				height: 13,
				x: 65.6,
				y: 119.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Q",
				width: 13,
				height: 13,
				x: 74.6,
				y: 93.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "R",
				width: 13,
				height: 13,
				x: 63.6,
				y: 57.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "S",
				width: 13,
				height: 13,
				x: 42.6,
				y: 72.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "T",
				width: 13,
				height: 13,
				x: 56.6,
				y: 26.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "U",
				width: 13,
				height: 13,
				x: 44.6,
				y: 114.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "V",
				width: 13,
				height: 13,
				x: 49.6,
				y: 148.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "W",
				width: 13,
				height: 13,
				x: 32.6,
				y: 158.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "X",
				width: 13,
				height: 13,
				x: 65.6,
				y: 172.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Y",
				width: 13,
				height: 13,
				x: 41.6,
				y: 205.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Z",
				width: 13,
				height: 13,
				x: 26.6,
				y: 181.6,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_13688",
						stdDeviation: 2.5
					})
				]
			})
		] })
	]
});
const SvgTreeWithLights = styled(base)({});
export default SvgTreeWithLights;
